/* Importer et calibrer ma photo : cadrage, qualité par format (DPI effectifs), ajout au panier.
   Le fichier final 300 DPI est généré côté serveur (relais Cloudflare) à partir de l'original + du cadrage. */
(function () {
  var CFG = window.CELESTIAR_CONFIG;
  var root = document.querySelector('[data-photo-importer]');
  if (!root || !CFG) return;

  var $ = function (name) { return root.querySelector('[data-pi="' + name + '"]'); };
  var T = {};
  try { T = JSON.parse(root.querySelector('[data-pi-i18n]').textContent); } catch (e) {}
  /* Liquid échappe les apostrophes en entités HTML : on les décode une fois. */
  (function () { var t = document.createElement('textarea'); Object.keys(T).forEach(function (k) { if (typeof T[k] === 'string') { t.innerHTML = T[k]; T[k] = t.value; } }); })();
  var VARIANTS = { poster: {}, hd: {} };
  try { VARIANTS = JSON.parse(root.querySelector('[data-pi-variants]').textContent); } catch (e) {}
  var UPLOAD_URL = (root.getAttribute('data-upload-url') || '').trim();
  var LOCALE = (T._locale === 'en') ? 'en-GB' : 'fr-FR';

  var el = {
    drop: $('drop'), input: $('input'), editor: $('editor'), canvas: $('canvas'), zoom: $('zoom'),
    portrait: $('portrait'), landscape: $('landscape'), formats: $('formats'), rights: $('rights'),
    qWrap: $('quality-confirm'), qBox: $('quality-box'), dWrap: $('digital-consent'), dBox: $('digital-box'),
    ctaHd: $('cta-hd'), ctaPoster: $('cta-poster'), msg: $('message'), info: $('info'), reset: $('reset')
  };

  var S = { file: null, bitmap: null, w: 0, h: 0, exif: 1, orient: 'portrait', fmt: null, zoom: 1, cx: 0, cy: 0, busy: false };

  function track(name, params) {
    try {
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) {}
  }
  function tpl(s, vars) { return String(s || '').replace(/\[(\w+)\]/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; }); }
  function money(v) { return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: 'EUR' }).format(Number(v) / 100); }
  function say(text, kind) {
    el.msg.textContent = text || '';
    el.msg.className = 'pi__msg' + (kind ? ' pi__msg--' + kind : '');
    el.msg.hidden = !text;
  }

  /* ---------- Géométrie ---------- */
  function target(fmt) {
    var p = S.orient === 'portrait';
    return { mmW: p ? fmt.mmW : fmt.mmH, mmH: p ? fmt.mmH : fmt.mmW, pxW: p ? fmt.pxW : fmt.pxH, pxH: p ? fmt.pxH : fmt.pxW };
  }
  function cropSize(fmt, zoom) {
    var t = target(fmt), a = t.pxW / t.pxH, cw, ch;
    if (S.w / S.h > a) { ch = S.h; cw = S.h * a; } else { cw = S.w; ch = S.w / a; }
    return { cw: cw / zoom, ch: ch / zoom, t: t };
  }
  function clampCenter(c) {
    S.cx = Math.min(S.w - c.cw / 2, Math.max(c.cw / 2, S.cx));
    S.cy = Math.min(S.h - c.ch / 2, Math.max(c.ch / 2, S.cy));
  }
  function dpiEff(fmt) { var c = cropSize(fmt, S.zoom); return c.cw / (c.t.mmW / 25.4); }
  function level(dpi) { return dpi >= CFG.DPI_GREEN ? 'green' : (dpi >= CFG.DPI_ORANGE ? 'orange' : 'red'); }
  function isIdeal(fmt) {
    var t = target(fmt), a = t.pxW / t.pxH, r = S.w / S.h;
    return Math.abs(r - a) / a <= CFG.IDEAL_RATIO_TOLERANCE;
  }

  /* ---------- Lecture du fichier ---------- */
  function exifOrientation(buf) {
    try {
      var v = new DataView(buf);
      if (v.getUint16(0) !== 0xFFD8) return 1;
      var off = 2;
      while (off < v.byteLength - 4) {
        var marker = v.getUint16(off); off += 2;
        if (marker === 0xFFE1) {
          if (v.getUint32(off + 2) !== 0x45786966) return 1;
          var tiff = off + 8, little = v.getUint16(tiff) === 0x4949;
          var ifd = tiff + v.getUint32(tiff + 4, little), n = v.getUint16(ifd, little);
          for (var i = 0; i < n; i++) {
            var e = ifd + 2 + i * 12;
            if (v.getUint16(e, little) === 0x0112) return v.getUint16(e + 8, little);
          }
          return 1;
        }
        if ((marker & 0xFF00) !== 0xFF00) break;
        off += v.getUint16(off);
      }
    } catch (e) {}
    return 1;
  }
  function isHeic(f) { return /hei[cf]/i.test(f.type) || /\.hei[cf]$/i.test(f.name); }
  function loadScript(src) {
    return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
  }
  function decode(file) {
    var opts = { imageOrientation: 'from-image' };
    return createImageBitmap(file, opts).catch(function () { return createImageBitmap(file); });
  }

  function handleFile(file) {
    say('');
    if (!file) return;
    var okType = /^image\/(jpeg|png|webp)$/i.test(file.type) || isHeic(file);
    if (!okType) { say(T.error_type, 'error'); return; }
    if (file.size > CFG.MAX_UPLOAD_MB * 1024 * 1024) { say(tpl(T.error_size, { mb: CFG.MAX_UPLOAD_MB }), 'error'); return; }
    var work = file;
    var chain = decode(file).catch(function () {
      if (!isHeic(file)) throw new Error('decode');
      say(T.heic_converting);
      return loadScript(root.getAttribute('data-heic-src')).then(function () {
        return window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 });
      }).then(function (out) {
        var blob = Array.isArray(out) ? out[0] : out;
        work = new File([blob], file.name.replace(/\.hei[cf]$/i, '.jpg'), { type: 'image/jpeg' });
        return decode(work);
      });
    });
    chain.then(function (bmp) {
      return work.slice(0, 131072).arrayBuffer().then(function (buf) {
        S.file = work; S.bitmap = bmp; S.w = bmp.width; S.h = bmp.height; S.exif = exifOrientation(buf);
        S.orient = S.h >= S.w ? 'portrait' : 'landscape';
        S.zoom = 1; S.cx = S.w / 2; S.cy = S.h / 2; S.fmt = null;
        say('');
        el.drop.hidden = true; el.editor.hidden = false;
        buildFormats(); pickDefault(); refresh();
        track('upload_photo', { width: S.w, height: S.h, size_mb: Math.round(work.size / 1048576 * 10) / 10 });
      });
    }).catch(function () { say(isHeic(file) ? T.error_heic : T.error_decode, 'error'); });
  }

  /* ---------- Interface ---------- */
  function buildFormats() {
    el.formats.innerHTML = '';
    CFG.FORMATS.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pi-format'; b.dataset.id = f.id;
      b.innerHTML = '<span class="pi-format__top"><strong>' + f.label + '</strong><em class="pi-format__ideal" hidden>' + T.ideal + '</em></span>' +
        '<span class="pi-format__px"></span><span class="pi-format__q"><i></i><span></span></span>';
      b.addEventListener('click', function () { selectFormat(f.id); });
      el.formats.appendChild(b);
    });
  }
  function pickDefault() {
    var best = null;
    CFG.FORMATS.forEach(function (f) {
      var ok = level(dpiEff(f)) !== 'red';
      if (ok && isIdeal(f) && (!best || f.mmW > best.mmW)) best = f;
    });
    selectFormat((best || CFG.FORMATS[0]).id, true);
  }
  function selectFormat(id, silent) {
    S.fmt = CFG.FORMATS.filter(function (f) { return f.id === id; })[0];
    S.zoom = 1; el.zoom.value = 1;
    S.cx = S.w / 2; S.cy = S.h / 2;
    refresh();
    if (!silent) track('select_format', { format: id });
  }
  function currentLevel() { return S.fmt ? level(dpiEff(S.fmt)) : 'red'; }

  function refresh() {
    if (!S.bitmap || !S.fmt) return;
    var c = cropSize(S.fmt, S.zoom); clampCenter(c);
    var cv = el.canvas, ratio = c.t.pxW / c.t.pxH, maxW = Math.min(440, el.editor.clientWidth || 440);
    cv.width = Math.round(Math.min(maxW, 520 * ratio)); cv.height = Math.round(cv.width / ratio);
    cv.getContext('2d').drawImage(S.bitmap, S.cx - c.cw / 2, S.cy - c.ch / 2, c.cw, c.ch, 0, 0, cv.width, cv.height);

    el.portrait.classList.toggle('active', S.orient === 'portrait');
    el.landscape.classList.toggle('active', S.orient === 'landscape');

    Array.prototype.forEach.call(el.formats.children, function (b) {
      var f = CFG.FORMATS.filter(function (x) { return x.id === b.dataset.id; })[0];
      var d = Math.round(dpiEff(f)), lv = level(d), t = target(f);
      b.classList.toggle('active', f === S.fmt);
      b.querySelector('.pi-format__ideal').hidden = !isIdeal(f);
      b.querySelector('.pi-format__px').textContent = t.pxW + ' × ' + t.pxH + ' px';
      b.querySelector('.pi-format__q i').className = 'pi-dot pi-dot--' + lv;
      b.querySelector('.pi-format__q span').textContent = tpl(T.dpi_label, { dpi: d }) + ' · ' + T['q_' + lv];
    });

    var d0 = Math.round(dpiEff(S.fmt)), lv0 = level(d0);
    el.info.className = 'pi__info pi__info--' + lv0;
    el.info.textContent = tpl(T.dpi_label, { dpi: d0 }) + ' · ' + T['q_' + lv0] + (lv0 === 'red' ? ' — ' + T.small_source : '');
    el.qWrap.hidden = lv0 === 'green';
    if (lv0 !== 'green' && !el.qWrap.dataset.shown) { el.qWrap.dataset.shown = '1'; track('quality_warning_shown', { level: lv0, format: S.fmt.id, dpi: d0 }); }
    if (lv0 === 'green') { el.qWrap.dataset.shown = ''; el.qBox.checked = false; }

    ['poster', 'hd'].forEach(function (k) {
      var v = VARIANTS[k] && VARIANTS[k][S.fmt.label];
      var btn = k === 'hd' ? el.ctaHd : el.ctaPoster;
      btn.querySelector('[data-pi-price]').textContent = v ? money(v.price) : '—';
      btn.dataset.variant = v ? v.id : '';
    });
    el.dWrap.hidden = false;
  }

  /* ---------- Cadrage à la souris / au doigt ---------- */
  var drag = null;
  el.canvas.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, y: e.clientY }; el.canvas.setPointerCapture(e.pointerId); });
  el.canvas.addEventListener('pointermove', function (e) {
    if (!drag || !S.fmt) return;
    var c = cropSize(S.fmt, S.zoom), k = c.cw / el.canvas.getBoundingClientRect().width;
    S.cx -= (e.clientX - drag.x) * k; S.cy -= (e.clientY - drag.y) * k;
    drag = { x: e.clientX, y: e.clientY }; refresh();
  });
  ['pointerup', 'pointercancel'].forEach(function (n) { el.canvas.addEventListener(n, function () { drag = null; }); });
  el.zoom.addEventListener('input', function () { S.zoom = Number(el.zoom.value); refresh(); });
  el.portrait.addEventListener('click', function () { S.orient = 'portrait'; S.cx = S.w / 2; S.cy = S.h / 2; refresh(); });
  el.landscape.addEventListener('click', function () { S.orient = 'landscape'; S.cx = S.w / 2; S.cy = S.h / 2; refresh(); });
  el.reset.addEventListener('click', function () {
    S.file = null; S.bitmap = null; el.editor.hidden = true; el.drop.hidden = false; el.input.value = ''; say('');
  });

  /* ---------- Dépôt du fichier ---------- */
  el.input.addEventListener('change', function () { handleFile(el.input.files[0]); });
  ['dragenter', 'dragover'].forEach(function (n) { el.drop.addEventListener(n, function (e) { e.preventDefault(); el.drop.classList.add('over'); }); });
  ['dragleave', 'drop'].forEach(function (n) { el.drop.addEventListener(n, function (e) { e.preventDefault(); el.drop.classList.remove('over'); }); });
  el.drop.addEventListener('drop', function (e) { handleFile(e.dataTransfer.files[0]); });

  /* ---------- Envoi + panier ---------- */
  function setBusy(b) { S.busy = b; el.ctaHd.disabled = b; el.ctaPoster.disabled = b; }

  function order(kind) {
    if (S.busy || !S.fmt) return;
    track('toggle_support', { support: kind });
    var btn = kind === 'hd' ? el.ctaHd : el.ctaPoster, variantId = btn.dataset.variant;
    if (!variantId) { say(T.error_variant, 'error'); return; }
    if (!el.rights.checked) { say(T.error_rights, 'error'); el.rights.focus(); return; }
    if (currentLevel() !== 'green' && !el.qBox.checked) { say(T.error_quality, 'error'); el.qBox.focus(); return; }
    if (kind === 'hd' && !el.dBox.checked) { say(T.error_consent, 'error'); el.dBox.focus(); return; }
    if (!UPLOAD_URL) { say(T.upload_unavailable, 'error'); return; }

    var c = cropSize(S.fmt, S.zoom); clampCenter(c);
    var crop = { x: Math.round(S.cx - c.cw / 2), y: Math.round(S.cy - c.ch / 2), w: Math.round(c.cw), h: Math.round(c.ch),
      srcW: S.w, srcH: S.h, exifOrientation: S.exif, orientation: S.orient, format: S.fmt.id,
      outW: c.t.pxW, outH: c.t.pxH, dpi: CFG.DPI_TARGET, effectiveDpi: Math.round(dpiEff(S.fmt)) };
    var fd = new FormData(); fd.append('file', S.file, S.file.name); fd.append('crop', JSON.stringify(crop)); fd.append('support', kind === 'hd' ? 'digital' : 'poster_unframed');
    setBusy(true); say(T.uploading);
    fetch(UPLOAD_URL.replace(/\/$/, '') + '/upload', { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok) throw new Error('upload'); return r.json(); })
      .then(function (up) {
        var props = {
          'Support': kind === 'hd' ? T.support_hd : T.support_poster,
          'Format': S.fmt.label,
          'Orientation': S.orient === 'portrait' ? T.portrait : T.landscape,
          '_support': kind === 'hd' ? 'digital' : 'poster_unframed',
          '_source_image': up.id,
          '_crop': JSON.stringify(crop),
          '_dpi_effectif': String(crop.effectiveDpi),
          '_droits_image': 'confirme'
        };
        if (kind === 'hd') props['_renonciation_retractation'] = 'confirmee';
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('cart'); track('add_to_cart', { support: kind, format: S.fmt.id }); window.location.href = '/cart'; })
      .catch(function () { setBusy(false); say(T.error_upload, 'error'); });
  }
  el.ctaHd.addEventListener('click', function () { order('hd'); });
  el.ctaPoster.addEventListener('click', function () { order('poster'); });
})();
